import { render, staticRenderFns } from "./ThemeTableSkeletonItem.vue?vue&type=template&id=2aef8551&scoped=true"
var script = {}
import style0 from "./ThemeTableSkeletonItem.vue?vue&type=style&index=0&id=2aef8551&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aef8551",
  null
  
)

export default component.exports